import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { CommunityComponent } from '../community/community/community.component';
import { buildCommunityTheme } from './community-theme';
import { CommunityLayoutService } from './community-layout.service';

/**
 * v2 community shell. Inherits all access, blocking and feature checks from
 * CommunityComponent and only replaces the layout and theming.
 */
@Component({
  selector: 'app-community-v2',
  templateUrl: './community-v2.component.html',
  styleUrls: ['./community-v2.component.scss'],
})
export class CommunityV2Component extends CommunityComponent implements OnInit, OnDestroy {
  private readonly themeSource = inject(CommanSubscribeService);
  readonly layout = inject(CommunityLayoutService);
  private themeSub?: Subscription;
  private appliedVars: string[] = [];

  override ngOnInit(): void {
    super.ngOnInit();
    this.applyTheme(this.themeSource.icWebpageSettingsData);
    this.themeSub = this.themeSource.getICWebpageThemeSettings().subscribe(s => this.applyTheme(s));
  }

  /** Vars go on :root so menus and dialogs rendered in overlays get them too. */
  private applyTheme(settings: any): void {
    if (!settings) return;
    const { vars } = buildCommunityTheme(settings);
    const root = document.documentElement.style;
    Object.entries(vars).forEach(([k, v]) => root.setProperty(k, v));
    this.appliedVars = Object.keys(vars);
  }

  closeRail(): void {
    this.layout.setRailOpen(false);
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.themeSub?.unsubscribe();
    const root = document.documentElement.style;
    this.appliedVars.forEach(k => root.removeProperty(k));
    this.layout.setRailOpen(false);
  }
}
